import { connect } from "react-redux";
import { formValueSelector } from "redux-form";

import Update from "./HelpfulLinkUpdate";
import { update, load2Update } from "../../../../../redux/modules/marketing/helpfulLink";

const selector = formValueSelector("helpfulLink");
const mstp = (state) => ({
    loading: state.helpfulLink.loading,
    photo: selector(state, "photo"),
    userInfo: state.login.userInfo,
});

const mdtp = { update, load2Update };

export default connect(mstp, mdtp)(Update);
